import { types as MutationTypes } from './mutations'
import debounce from 'lodash/debounce'
import { getWarehouseList } from '@/api/warehouse'
import { getInventories, getInboundList, syncStock, checkSyncStock } from '@/api/inventory'
import { getChannelWarehouse, getConnectedWarehouseChannelList } from '@/api/channels/index'
import { getShopeeWarehouseChannelList } from '@/api/channels/shopee'
import { getLazadaWarehouseChannelList } from '@/api/channels/lazada'
import { getBlibliPickupPoint } from '@/api/channels/blibli'
import { getTiktokWarehouseChannelList } from '@/api/channels/tiktok'
import { getZaloraWarehouseChannelList } from '@/api/channels/zalora'

export const GETSALESWAREHOUSE = async ({ commit }, params) => {
  let data = ''
  try {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: true,
    })

    const response = await getWarehouseList(params)
    data = response?.data || {}

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      warehouse: data?.data || {},
      loading: false,
    })
  }
}

export const GETWAREHOUSELIST = async (
  { commit }, { business_id = '', warehouse_id = undefined, channel_code = '', page = undefined, size = undefined, query = undefined },
) => {
  let data = ''
  try {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: true,
    })
    const { data: response} = await getWarehouseList({ business_id, warehouse_id, channel_code, page, size, query })
    data = await response.data.map((obj) => {
      return {
        ...obj,
        value: obj.id,
        label: obj.name,
        checked: true,
      }
    })
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: true,
      warehouseList: data ?? [],
    })
  }
}

export const GETINVENTORYLIST = async (
  { commit }, { page = 1, size = 10, status, warehouseId, business_id, sort },
) => {
  try {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: true,
    })

    const { data: response} = await getInventories({
      page,
      size,
      status,
      warehouseId,
      business_id,
      sort,
    })
    return Promise.resolve(response)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: false,
    })
  }
}

export const GETINBOUNDLIST = async (
  { commit }, { page = 1, size = 10, type, warehouseId, business_id, catalog_id, sort },
) => {
  try {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: true,
    })

    let parameter = {
      page,
      size,
      type,
      warehouse_id: warehouseId,
      business_id,
      catalog_id,
      sort,
    }

    if (!parameter.catalog_id) {
      delete parameter.catalog_id
    }

    const { data: response} = await getInboundList(parameter)
    return Promise.resolve(response)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: false,
    })
  }
}

export const GETWAREHOUSECHANNELLISTV2 = async (
  { commit },
  { business_id, channel_id, channel_code },
) => {
  try {
    commit(MutationTypes.SET_WAREHOUSE_STORE, { loading: true })

    let resWarehouse
    if (['tiktok', 'tiktok_id'].includes(channel_code)) {
      resWarehouse = await getTiktokWarehouseChannelList({ business_id, channel_id })
    } else if (['zalora_id', 'zalora'].includes(channel_code)) {
      resWarehouse = await getZaloraWarehouseChannelList({ business_id, channel_id })
    } else {
      resWarehouse = await getChannelWarehouse({
        business_id,
        channel_code: channel_code === 'blibli_id' ? 'blibli' : channel_code,
        channel_id,
        connected: true,
      })
    }

    const { data: response } = resWarehouse
    let data
    if (['blibli_id', 'lazada_id'].includes(channel_code)) {
      data = response?.data
    } else if (['shopee_id', 'shopee'].includes(channel_code)) {
      data = response?.data?.warehouses || response
    } else if (['tokopedia_id'].includes(channel_code)) {
      data = response
    } else if (['tiktok', 'tiktok_id', 'zalora_id', 'zalora', 'tiktok_tokopedia'].includes(channel_code)) {
      data = response?.data?.warehouse_list
    } else {
      data = response?.data?.data
    }

    let keyWhsMasterId
    if (channel_code === 'blibli_id') {
      keyWhsMasterId = 'master_warehouse_id'
    } else if (['tiktok', 'tiktok_id', 'lazada_id', 'zalora_id', 'zalora', 'tiktok_tokopedia'].includes(channel_code)) {
      keyWhsMasterId = 'warehouse_id'
    } else {
      keyWhsMasterId = 'warehouse_master_id'
    }

    let keyWhsChannelId
    if (['lazada_id', 'tiktok', 'tiktok_id', 'zalora_id', 'zalora', 'tiktok_tokopedia', 'shopee_id', 'shopee'].includes(channel_code)) {
      keyWhsChannelId = 'channel_warehouse_id'
    } else {
      keyWhsChannelId = 'id'
    }

    let keyWhsChannelName
    if (['blibli_id', 'lazada_id', 'tiktok', 'tiktok_id', 'zalora_id', 'zalora', 'tiktok_tokopedia'].includes(channel_code)) {
      keyWhsChannelName = 'name'
    } else if (['shopee_id', 'shopee'].includes(channel_code)) {
      keyWhsChannelName = 'warehouse_name'
    } else {
      keyWhsChannelName = 'warehouse_channel_name'
    }
    const normalized = Array.isArray(data)
      ? data.reduce((acc, warehouse) => {
          const masterId = warehouse?.[keyWhsMasterId] || null
          acc.push({
            raw: warehouse,
            warehouse_master_id: masterId,
            warehouse_channel_id: warehouse?.[keyWhsChannelId],
            warehouse_channel_name: warehouse?.[keyWhsChannelName] || 'Default Warehouse',
          })
          return acc
        }, [])
      : []

    return normalized
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(MutationTypes.SET_WAREHOUSE_STORE, { loading: false })
  }
}

export const GETSHOPEEWAREHOUSECHANNELLIST = async (
  { commit }, { channel_id },
) => {
  let data = ''
  try {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: true,
    })
    const { data: response} = await getShopeeWarehouseChannelList({ channel_id })
    data = response[0]?.warehouses.map((obj) => {
      return {
        value: String(obj.locationId),
        label: obj.warehouseName,
      }
    })
    if (!data) {
      data = [
        {
          value: '',
          label: 'Default Warehouse',
        },
      ]
    }
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: true,
      warehouseChannelList: data ?? [],
    })
  }
}

export const GETLAZADAWAREHOUSECHANNELLIST = async (
  { commit }, { channel_id },
) => {
  let data = ''
  try {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: true,
    })
    const { data: response} = await getLazadaWarehouseChannelList({ channel_id })
    data = response?.data.map((obj) => {
      return {
        value: String(obj.channel_warehouse_id),
        label: obj.name || 'Default Warehouse',
      }
    })
    if (!data) {
      data = [
        {
          value: '',
          label: 'Default Warehouse',
        },
      ]
    }
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: true,
      warehouseChannelList: data ?? [],
    })
  }
}

export const GETBLIBLIWAREHOUSECHANNELLIST = async (
  { commit }, { business_id, channel_id },
) => {
  let data = ''
  try {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: true,
    })
    const { data: response} = await getBlibliPickupPoint({ business_id, channel_id })
    data = response?.data.map((obj) => {
      return {
        value: String(obj.id),
        label: obj.display_name || 'Default Warehouse',
      }
    })
    if (!data) {
      data = [
        {
          value: '',
          label: 'Default Warehouse',
        },
      ]
    }
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: true,
      warehouseChannelList: data ?? [],
    })
  }
}

export const GETCONNECTEDWAREHOUSECHANNELLIST = async (
  { commit }, { channel_id, sales_channel, business_id },
) => {
  let data = ''
  try {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: true,
    })
    const { data: response} = await getConnectedWarehouseChannelList({ sales_channel, channel_id, business_id })
    data = response
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(MutationTypes.SET_WAREHOUSE_STORE, {
      loading: true,
      warehouseChannelList: data ?? [],
    })
  }
}

export const SYNCWAREHOUSESTOCK = async ({ commit, dispatch }, payload) => {
  commit(MutationTypes.SET_SYNCING, true)

  let requests = []
  let warehouses = []
  payload.warehouses.forEach(warehouse => {
    warehouses.push(warehouse.key)
    requests.push(syncStock({
      business_id: payload.business_id,
      params: {
        warehouse_id: warehouse.key,
      },
    }))
  })

  commit(MutationTypes.SET_WAREHOUSES, warehouses)
  await Promise.all(requests)
    .then(() => dispatch('CHECKSYNCWAREHOUSESTOCK', payload))
    .catch(err => {
      commit(MutationTypes.SET_SYNCING, false)
      console.error(err)
    })
}

export const CHECKSYNCWAREHOUSESTOCK = debounce(async ({ commit, dispatch }, payload) => {
  let requests = []
  payload.warehouses.forEach(warehouse => {
    requests.push(checkSyncStock({
      business_id: payload.business_id,
      params: {
        warehouse_id: warehouse.key,
      },
    }))
  })
  await Promise.all(requests)
    .then(response => {
      if(response.some(res => res.data.status === 'ONPROGRESS')) {
        dispatch('CHECKSYNCWAREHOUSESTOCK', payload)
      } else {
        let success = []
        let error = []
        response.forEach((res, index) => {
          if(res.data.status === 'SUCCESS') {
            success.push(payload.warehouses[index].label)
          } else {
            error.push(payload.warehouses[index].label)
          }
        })
        commit(MutationTypes.SET_STATUS, {
          success,
          error,
        })
        commit(MutationTypes.SET_WAREHOUSES, [])
        commit(MutationTypes.SET_MESSAGE, true)
        commit(MutationTypes.SET_SYNCING, false)
      }
    })
    .catch(err => {
      commit(MutationTypes.SET_SYNCING, false)
      console.error(err)
    })
}, 1000)
